/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { cached } from '@glimmer/tracking';
import { type Registry as Services, service } from '@ember/service';
import UserModel from 'uplisting-frontend/models/user';
import BookingModel from 'uplisting-frontend/models/booking';

interface IArgs {
  booking: BookingModel;
}

export interface BookingSignature {
  Element: HTMLDivElement;

  Args: IArgs;

  Blocks: {
    default: [];
  };
}

export default class UiBookingComponent extends Component<BookingSignature> {
  @service router!: Services['router'];
  @service session!: Services['session'];

  @cached
  get booking(): BookingModel {
    return this.args.booking;
  }

  @cached
  get currentUser(): UserModel {
    return this.session.currentUser as UserModel;
  }

  @cached
  get currentRouteName(): string {
    return this.router.currentRouteName ?? '';
  }

  @cached
  get canEditPrice(): boolean {
    return (
      this.currentUser.hasAccessTo('bookings.price') &&
      this.booking.isPriceEditable
    );
  }

  @cached
  get canMessageGuest(): boolean {
    return (
      this.currentUser.hasAccessTo('bookings.messages') &&
      this.booking.canSendMessage
    );
  }

  @cached
  get canSeeGuestIdentity(): boolean {
    return !!(
      this.currentUser.hasAccessTo('bookings.identity') &&
      this.booking.guestIdentityVerification?.succeeded
    );
  }

  @cached
  get isViewingReplies(): boolean {
    return this.currentRouteName.includes('bookings.replies');
  }

  @cached
  get isActionBookings(): boolean {
    return this.currentRouteName.startsWith('action.bookings');
  }

  @cached
  get summaryRoute(): string {
    if (this.isActionBookings) {
      return 'action.bookings.summary.index';
    }

    return '';
  }

  @cached
  get priceRoute(): string {
    if (this.isActionBookings) {
      return 'action.bookings.price';
    }

    return '';
  }

  @cached
  get messagesRoute(): string {
    if (this.isActionBookings) {
      return 'action.bookings.messages';
    }

    return '';
  }

  @cached
  get detailsRoute(): string {
    if (this.isActionBookings) {
      return 'action.bookings.details';
    }

    return '';
  }

  @cached
  get identityRoute(): string {
    if (this.isActionBookings) {
      return 'action.bookings.identity';
    }

    return '';
  }

  @cached
  get logsRoute(): string {
    if (this.isActionBookings) {
      return 'action.bookings.logs';
    }

    return '';
  }

  @cached
  get indexRoute(): string {
    if (this.currentRouteName.startsWith('action')) {
      return 'action';
    }

    return '';
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::Booking': typeof UiBookingComponent;
  }
}
